export type MediaState = { call: string; mic: boolean; camera: boolean };

export function afterMediaToggle(state: MediaState, which: "mic" | "camera"): MediaState {
  return which === "mic" ? { ...state, mic: !state.mic } : { ...state, camera: !state.camera };
}

let carrying = false;

export function noteTheMic(state: { mic: boolean; speaking: boolean }): void {
  carrying = state.mic && state.speaking;
}

export function micIsCarrying(): boolean {
  return carrying;
}
